import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ExamRoute from './ExamRoute';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import loadable from '@loadable/component';
import UpdateQuestionPaper from 'components/question-paper/modal/UpdateQuestionPaper';
import Batch from 'components/master-data/Batch';
import AddBatch from 'components/master-data/modal/AddBatch';
import ProjectMaster from 'components/master-data/ProjectMaster';
import ViewBatchProjectDetail from 'components/master-data/sub-screens/ViewBatchProjectDetail';
import QuestionBank from 'components/question-bank/QuestionBank';
import NewQuestionPaper from 'components/question-paper/modal/NewQuestionPaper';

const Aptitude = loadable(() => import('components/question-bank/Aptitude'), { fallback: <LoadingIndicator /> });
const Analytics = loadable(() => import('components/question-bank/Analytics'), { fallback: <LoadingIndicator /> });
const AddQuestion = loadable(() => import('components/question-bank/modal/AddQuestion'), { fallback: <LoadingIndicator /> });
const Technical = loadable(() => import('components/question-bank/Technical'), { fallback: <LoadingIndicator /> });
const QuestionPaper = loadable(() => import('components/question-paper/QuestionPaper'), { fallback: <LoadingIndicator /> });

const QuestionRoute: React.FC = () => {
    return (
        <div>
            {/* <RouteChangeCanceler /> */}
            {/* <LayoutPage> */}
            <Routes>
                <Route path="/aptitude/*" element={<Aptitude />} />
                <Route path="/analytics/*" element={<Analytics />} />
                <Route path="/technical/*" element={<Technical />} />
                <Route path="/aptitude/add-questionbank" element={<AddQuestion />} />
                <Route path="/analytics/add-questionbank" element={<AddQuestion />} />
                <Route path="/technical/add-questionbank" element={<AddQuestion />} />
                <Route path="/question-paper/*" element={<QuestionPaper />} />
                <Route path='/question-bank' element={<QuestionBank />} />
                {/* <Route path="/question-paper/add-question-paper" element={<AddQuestionPaper />} /> */}
                <Route path="/batch" element={<Batch />} />
                <Route path="/batch/add-batch" element={<AddBatch />} />
                <Route path="/project" element={<ProjectMaster />} />
                <Route path="/project/add-project" element={<AddBatch />} />
                <Route path="/batch/view-details" element={<ViewBatchProjectDetail />} />
                <Route path="/project/view-details" element={<ViewBatchProjectDetail />} />
                <Route path='/question-paper/create-question-paper' element={<UpdateQuestionPaper />} />
                <Route path="*" element={<ExamRoute />} />
            </Routes>
            {/* </LayoutPage> */}
        </div>
    )
}

export default QuestionRoute;